import type {Expand} from '../types';

import {courseExpandCommon} from '../course';
import {userExpandCommon} from '../user';

export const conferenceExpandCommon: Expand = {
  conference: [
    ['course_id', null, courseExpandCommon],
    ['client_id', {name: 'Client not found'}, userExpandCommon],
    ['coach_ids->coaches', {name: 'User not found'}, userExpandCommon],
    'archives.file_id',
  ],
};
